import React, { useState } from "react"
import { validateEmail } from "../../helpers/email-input.helper"
import dataLayerHelper from "../../helpers/datalayer.helper"
import { landingPagesEventHandler } from "../../../email/landingPages.function"

import {
  EmailSubscribeHorizontalContainer,
  EmailSubscribeHorizontalSubTitle,
  EmailSubscribeHorizontalTitle,
  EmailSubscribeHorizontalInput,
  EmailSubscribeHorizontalError,
  StatusIcon,
  EmailSubscribeHorizontalFormContainer,
  EmailSubscribeHorizontalRightContainer,
} from "./email-subscribe-horizontal.styles"

import ButtonLink from "../btn-collections/btn-collections.component"

const EmailSubscribeHorizontal = ({
  label,
}) => {
  let slug = typeof window !== "undefined" ? window.location.pathname : ""

  const updateGTM = (status) => {
    dataLayerHelper({
      event: "emailSubscriber",
      location: slug,
      status,
      cta_identifier: slug,
    })
  }

  const postSubscriber = async (email) => {
    try {
      // VALIDATE EMAIL
      if (!validateEmail(email)) {
        setStatusText(
          `Please provide a valid email address to stay up to date!`
        )
        setStatusStyle(`error`)
        return
      }

      const handler = await landingPagesEventHandler({ email, pageSlug: slug })

      // Handle successful submission
      if (handler.status === 200) {
        setStatusText(
          `Thanks for signing up. You should receive an email shortly. If not, make sure we didn't end up in your spam box 🙂!`
        )
        setStatusStyle("success")
        updateGTM("Subscribe Success")
      }

      // Handle failed submission
      else {
        setStatusText(`An error occured, please try again!`)
        setStatusStyle(`error`)
      }
    } catch (error) {
      setStatusText(`An error occured, please try again!`)
      setStatusStyle(`error`)
    }
  }

  const [email, setEmail] = useState("")
  const [statusText, setStatusText] = useState(label)
  const [statusStyle, setStatusStyle] = useState(`default`)

  const handleEmailChange = (email) => {
    setEmail(email.target.value.trim())
  }
  const buttonHandler = () => postSubscriber(email)

  return (
    <EmailSubscribeHorizontalContainer gridColumn={"1 / -1"}>
      <EmailSubscribeHorizontalTitle>
        {statusStyle !== "success" ? label : statusText}
      </EmailSubscribeHorizontalTitle>
      <EmailSubscribeHorizontalSubTitle>
        {statusStyle !== "success" ? "No spam ever, unsubscribe anytime." : ""}
      </EmailSubscribeHorizontalSubTitle>

      <EmailSubscribeHorizontalRightContainer>
        {statusStyle === "error" ? (
          <EmailSubscribeHorizontalError>
            {statusText}
          </EmailSubscribeHorizontalError>
        ) : null}
        <EmailSubscribeHorizontalFormContainer>
          <EmailSubscribeHorizontalInput
            statusStyle={statusStyle}
            placeholder="Email"
            onKeyDown={(e) =>
              e.key === "Enter" ? postSubscriber(email) : null
            }
            onChange={handleEmailChange}
            type="email"
            autoComplete="email"
          />
          <ButtonLink isButton onClick={buttonHandler}>
            SUBSCRIBE
          </ButtonLink>
          {displayStatusIcon(statusStyle)}
        </EmailSubscribeHorizontalFormContainer>
      </EmailSubscribeHorizontalRightContainer>
    </EmailSubscribeHorizontalContainer>
  )
}

export default EmailSubscribeHorizontal

// This function returns the relevant validation svg should one apply
const displayStatusIcon = (state) => {
  if (state === "error")
    return (
      <StatusIcon statusStyle={state}>
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="11.5" cy="11.5" r="11.5" fill="#EB000E" />
          <line
            x1="16.3809"
            y1="6.78275"
            x2="6.78421"
            y2="16.3794"
            stroke="white"
          />
          <line
            x1="16.4121"
            y1="16.3794"
            x2="6.81539"
            y2="6.78275"
            stroke="white"
          />
        </svg>
      </StatusIcon>
    )

  if (state === "success")
    return (
      <StatusIcon statusStyle={state}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 23 23"
          width="23"
          height="23"
        >
          <circle fill="#1c8000" cx="11.5" cy="11.5" r="11.5" />
          <path
            stroke="white"
            d="M 17.3789 6.78271 L 8.33081 15.8308 L 4.65625 12.1562"
          />
        </svg>
      </StatusIcon>
    )
  else return null
}
